import React from 'react';

import PropTypes from 'prop-types';

const FireIcon = ({ color = 'currentColor', size = 32, ...rest }) => {
  return (
    <svg
      width={size * (16 / 21)}
      height={size}
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.98669 0.5C12.3226 4.44531 15.4867 9.13281 15.4867 12.2578C15.4867 17.1406 12.4008 20.5 7.98669 20.5C3.53357 20.5 0.486694 17.1406 0.486694 12.2578C0.486694 9.13281 3.57263 4.48438 7.98669 0.5ZM7.98669 18C10.7211 18 12.9867 15.9688 12.9476 13.4297C12.9476 11.0859 11.6195 9.95312 10.3304 8.82031C9.27576 7.96094 8.29919 7.10156 8.29919 5.8125C8.29919 5.61719 8.14294 5.57812 8.10388 5.53906C7.98669 5.5 7.79138 5.5 7.67419 5.65625C4.82263 9.5625 9.19763 9.28906 9.19763 12.1016C9.19763 13.2734 8.22107 14.2891 7.01013 14.2891C5.83826 14.2891 4.82263 13.2734 4.82263 12.1016V10.5391V10.5C4.82263 10.4219 4.82263 10.3438 4.74451 10.3047C4.62732 10.1875 4.43201 10.1875 4.31482 10.3047C3.96326 10.6172 2.98669 11.6719 2.98669 13.4297C2.98669 15.9688 5.21326 18 7.98669 18Z"
        fill={color}
      />
    </svg>
  );
};

FireIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FireIcon;
